import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import BookmarkArrow from "../partials/bookmark-arrow";
import SiteFooter from "../partials/site-footer";
import HelmetWrapper from "../partials/helmet-wrapper";
import SiteHeader from "../partials/site-header";
import TabbedContent from "../partials/tabbed-content";
import { setInLocal } from "../../utils/app-helpers";

const { siteMetadata: config } = GatsbyConfig;

export default class GalleryPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props;

    setInLocal("lsg.last-viewed-trip", trip);
  }

  render() {
    const { trip, location } = this.props;
    const selectedKey =
      location && `${location.search}`.match(/tab=[^&]+/i)
        ? location.search.replace(/.*\??tab=([^&]+).*/g, "$1")
        : "hawaii";
    const title = "Photo Gallery";
    const description =
      "See photos from some of our past Love Song Couples Getaway’s";

    return (
      <div className={`page-gallery trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader trip={trip} lock />
        <main>
          <div
            style={{
              backgroundImage: `url(/images/gallery-${trip}-splash.jpg)`,
            }}
            className={`image gallery-${trip}-splash mobile-100x40 desktop-300`}
          />
          <div className="bookmark" id="gallery" />
          <TabbedContent
            willAnchor
            replaceState={`/${trip}/gallery/`}
            selectedKey={selectedKey}
            title="Photos of Past Getaways"
            data={JSON.stringify([
              {
                key: "hawaii",
                name: "Hawaii",
                slug: "",
                component: "Gallery",
                props: { folder: "hawaii", count: 28 },
              },
              {
                key: "bahamas",
                name: "Bahamas",
                slug: "?tab=bahamas",
                component: "Gallery",
                props: { folder: "bahamas", count: 28 },
              },
            ])}
          />
          <div className="content">
            <div className="wrap arrow-bar">
              <BookmarkArrow bookmark="gallery" direction="up" />
            </div>
          </div>
          <div className="quote">
            <div className="wrap">
              <p>
                <q>
                  What God has joined together, <br />
                  let no one separate
                </q>
                <cite>Matthew 19:6</cite>
              </p>
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/gallery.js